$(function () {
    $('.product-top__show-more').on('click', function () {
        $(this).toggleClass('active').siblings('.product-top__text').toggleClass('hidden');
    });

    if (document.querySelector('[data-product-container]')) {
        $('.zoom').zoom({
            magnify: 1.3,
        });

        var elem = document.getElementById("zoom2");
        Panzoom(elem, { contain: 'outside', startScale: 1 })

        $("[data-fancybox]").fancybox({
            protect: true,
            buttons: [
                'zoom',
                'thumbs',
                'close'
            ]
        });
    }

    $('[data-modal="modal-advant"]').on('click', function () {
        $('.modal-advant h3').text($(this).data('title'));
        $('.modal-advant p').text($(this).data('text'));
    });

    $('[data-modal="modal-complex"]').on('click', function () {
       $.ajax({
            url: "/ajax/benefit_of_food.php?id=" + $(this).data('id'),
            success: function (data) { 
                $('.modal-complex [data-modal-content]').html(data.data);
            },
            dataType: 'json'
        });
    });

    $('.calculator-tabs__header a').on('click', function (e) {
        e.preventDefault();
        $('.calculator-tabs__header a').removeClass('active');
        $(this).addClass('active');
        $('.product-tabs__calc-text').removeClass('active');
        $('.product-tabs__calc-form').removeClass('active');
        $('.product-tabs__calc-form[data-tab="' + $(this).data('tab') + '"]').addClass('active');
    });

    $('.product-tabs__calc-form').on('submit', function (e) {
        e.preventDefault();
        var thisValid = true;
        $(this).find('.simple-select__main input').each(function () {
            if ($(this).val().length === 0) {
                $(this).siblings('.simple-select__selected').addClass('wrong');
                thisValid = false;
            } else {
                $(this).siblings('.simple-select__selected').removeClass('wrong');
            }
        });

        if (thisValid == true) {
             $.ajax({
                 url: "/ajax/feeding_calculator.php?id=" + $(this).data('id') + "&form_id=" + $(this).data('formId'),
                 type: $(this).attr('method'),
                 data: $(this).serialize(),
                 dataType: 'json',
                 success: function (data) {
                     $('.product-tabs__calc-text').addClass('active');
                     $('.product-tabs__calc-text span').text(data.result + " г");
                 }
             });
        }
    });
});
